var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 63,
    viewBox: "0 0 120 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4.85,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 9.7,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 14.55,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 19.4,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 24.25,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 29.1,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 33.95,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 38.8,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 43.65,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 48.5,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 53.35,
    width: 120,
    height: 4.85,
    fill: "#FFFFFF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 58.2,
    width: 120,
    height: 4.85,
    fill: "#B22234"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 34,
    fill: "#3C3B6E"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6,4 6.5,5.5 8.1,5.5 6.8,6.5 7.3,8 6,7 4.7,8 5.2,6.5 3.9,5.5 5.5,5.5",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "16,4 16.5,5.5 18.1,5.5 16.8,6.5 17.3,8 16,7 14.7,8 15.2,6.5 13.9,5.5 15.5,5.5",
    fill: "#FFFFFF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "26,4 26.5,5.5 28.1,5.5 26.8,6.5 27.3,8 26,7 24.7,8 25.2,6.5 23.9,5.5 25.5,5.5",
    fill: "#FFFFFF"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "36,4 36.5,5.5 38.1,5.5 36.8,6.5 37.3,8 36,7 34.7,8 35.2,6.5 33.9,5.5 35.5,5.5",
    fill: "#FFFFFF"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "11,10 11.5,11.5 13.1,11.5 11.8,12.5 12.3,14 11,13 9.7,14 10.2,12.5 8.9,11.5 10.5,11.5",
    fill: "#FFFFFF"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "21,10 21.5,11.5 23.1,11.5 21.8,12.5 22.3,14 21,13 19.7,14 20.2,12.5 18.9,11.5 20.5,11.5",
    fill: "#FFFFFF"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "31,10 31.5,11.5 33.1,11.5 31.8,12.5 32.3,14 31,13 29.7,14 30.2,12.5 28.9,11.5 30.5,11.5",
    fill: "#FFFFFF"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "41,10 41.5,11.5 43.1,11.5 41.8,12.5 42.3,14 41,13 39.7,14 40.2,12.5 38.9,11.5 40.5,11.5",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.bbea67d4ca436591f54bcb5008104f85.svg";
export { ForwardRef as ReactComponent };